const Specialties = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-blue-50 to-white">
      
      {/* Hero Section */}
      <section className="pt-36 pb-16 lg:pt-40 lg:pb-24">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Content */}
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold text-blue-500 mb-6 leading-tight">
                Custom Billing Services{' '}
                <span className="text-gray-900">for Every Specialty</span>
              </h1>
              
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                We provide professional medical billing services specific to your medical practice using the latest reimbursement patterns in order to guarantee correct, compliant, and effective revenue cycles.
              </p>

              <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg">
                Contact Us
              </button>
            </div>

            {/* Right Image */}
            <div className="flex justify-center lg:justify-end">
              <img 
                src="/billing6.jpg" 
                alt="Medical Specialties" 
                className="w-full max-w-lg"
              />
            </div>

          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-0 -mt-8">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-blue-800 to-blue-600 rounded-3xl p-8 shadow-2xl">
            <form className="flex flex-col md:flex-row gap-4 items-center">
              <input
                type="text"
                placeholder="Enter Your Name"
                className="flex-1 px-6 py-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300 text-gray-700"
              />
              <input
                type="tel"
                placeholder="Mobile Number"
                className="flex-1 px-6 py-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300 text-gray-700"
              />
              <input
                type="email"
                placeholder="Email Address"
                className="flex-1 px-6 py-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300 text-gray-700"
              />
              <button
                type="submit"
                className="px-10 py-4 bg-white text-blue-800 font-bold rounded-lg hover:bg-gray-100 transition-colors shadow-lg whitespace-nowrap"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Specialties Grid Section */}
      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          <h2 className="text-3xl lg:text-4xl font-bold text-center mb-12 leading-tight">
            <span className="text-blue-500">Our Specialties</span>{' '}
            <span className="text-gray-900">in Medical Billing</span>{' '}
            <span className="text-blue-500">Services</span>
          </h2>

          {/* Specialties Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            
            {/* Behavioral Health */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Behavioral Health</h3>
            </div>

            {/* Family Practice */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Family Practice</h3>
            </div>

            {/* Gastroenterology */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Gastroenterology</h3>
            </div>

            {/* Urgent Care */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Urgent Care</h3>
            </div>

            {/* General Surgery */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9.17 6l2 2H20v10H4V6h5.17M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/>
                    <path d="M14 12h-2v-2h-2v2H8v2h2v2h2v-2h2v-2z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">General Surgery</h3>
            </div>

            {/* Pain Management */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5 0 1.93-1.57 3.5-3.5 3.5s-3.5-1.57-3.5-3.5C8.5 7.57 10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Pain Management</h3>
            </div>

            {/* Allergy & Immunology */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Allergy & Immunology</h3>
            </div>

            {/* Radiology Billing */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h16v12H4zm6.5-10.5h3v3h-3v-3zm0 4h3v3h-3v-3z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Radiology Billing</h3>
            </div>

            {/* Internal Medicine */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 9h-4v4h-4v-4H6V8h4V4h4v4h4v4z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Internal Medicine</h3>
            </div>

            {/* Critical Care */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Critical Care</h3>
            </div>

            {/* Cardiology */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Cardiology</h3>
            </div>

            {/* Nephrology */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Nephrology</h3>
            </div>

            {/* Pulmonology */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Pulmonology</h3>
            </div>

            {/* Neurology */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Neurology</h3>
            </div>

            {/* Ophthalmology */}
            <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all border border-gray-100">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                  </svg>
              </div>
              <h3 className="text-base font-bold text-gray-900">Ophthalmology</h3>
            </div>

          </div>

          <div className="text-center mt-12">
            <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg inline-flex items-center">
              View More Specialties
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Specialties;

